import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useHistory } from 'react-router';

import styles from './style.module.scss';
import { submitSpecialOffersLocalAccountCampaign } from 'src/api';
import { handleGoBack, goBack, gaTrackingAndLogAction } from 'src/utils';
import {
  LOCAL_ACCOUNT,
  LOCAL_ACCOUNT_STEP,
  LOCAL_ACCOUNT_TRACKING,
  SPECIAL_OFFERS_LOCAL_ACCOUNT_DETAIL_URL,
  CAMPAIGN_CODES,
  URL_PARAMS,
  ON_TO_OFF_ACTION_TYPE,
} from 'src/constants';

import InsurancePackageIcon from 'src/assets/special_offers_icon_1.png';
import InsuranceRefundIcon from 'src/assets/special_offers_icon_2.png';
import InsuranceBenefitIcon from 'src/assets/special_offers_icon_3.png';
import Checkbox from 'src/components/Checkbox';
import Button from 'src/components/Button';
import LoadingService from 'src/utils/LoadingService';
import PopupConfirm from 'src/components/PopupConfirm';
import LargeCheckWhite from 'src/assets/large_white_check.png';
import TextInput from 'src/components/TextInput';
import Toolbar from 'src/components/Toolbar';
import PreviewBanner from 'src/assets/preview-local-account.svg';

const SpecialOffersLocalAccountCampaign = (props) => {
  const { t } = useTranslation();
  const [rmCode, setRmCode] = useState('');
  const [isAgreeGetAdvise, setIsAgreeGetAdvise] = useState(false);
  const [isShowSuccessModal, setShowSuccessModal] = useState(false);
  const [isShowErrorModal, setShowErrorModal] = useState(false);
  const [isDirty, setDirty] = useState(false);
  const history = useHistory();
  const isRmCodeValid = useMemo(() => {
    const rmCodeValue = rmCode.trim();
    const rmCodeLength = rmCodeValue.length;
    return !isDirty || (rmCodeLength > 0 && rmCodeLength <= 12);
  }, [isDirty, rmCode]);

  const handleInputRmCode = useCallback((event) => {
    let value = event.target.value;
    event.target.value = value.slice(0, 12);
  }, []);

  const closeSuccessModal = useCallback(() => {
    setShowSuccessModal(false);
    document.body.style.overflow = 'unset';
    goBack();
  }, []);

  const handleToggleAgree = useCallback(() => {
    setIsAgreeGetAdvise(!isAgreeGetAdvise);

    if (isAgreeGetAdvise === false) {
      gaTrackingAndLogAction({
        pub: LOCAL_ACCOUNT_TRACKING,
        event: LOCAL_ACCOUNT[LOCAL_ACCOUNT_STEP.LOCAL_ACCOUNT_CHECKBOX],
        eventDirectory: CAMPAIGN_CODES.LOCAL_ACCOUNT,
        actionType: ON_TO_OFF_ACTION_TYPE,
      });
    }
  }, [isAgreeGetAdvise]);

  const handleSubmit = () => {
    const rmCodeValue = rmCode.trim();
    if (isRmCodeValid) {
      gaTrackingAndLogAction({
        pub: LOCAL_ACCOUNT_TRACKING,
        event: LOCAL_ACCOUNT[LOCAL_ACCOUNT_STEP.LOCAL_ACCOUNT_CONFIRM],
        eventDirectory: CAMPAIGN_CODES.LOCAL_ACCOUNT,
        actionType: ON_TO_OFF_ACTION_TYPE,
      });

      LoadingService.instance.current.open();
      submitSpecialOffersLocalAccountCampaign(rmCodeValue)
        .then((res) => {
          setShowSuccessModal(true);
        })
        .catch((error) => {
          console.log(error);
          setShowErrorModal(true);
        })
        .finally(() => {
          LoadingService.instance.current.close();
        });
    }
  };

  const handleViewDetail = (e) => {
    e.preventDefault();
    gaTrackingAndLogAction({
      pub: LOCAL_ACCOUNT_TRACKING,
      event: LOCAL_ACCOUNT[LOCAL_ACCOUNT_STEP.LOCAL_ACCOUNT_VIEW_DETAIL],
      eventDirectory: CAMPAIGN_CODES.LOCAL_ACCOUNT,
      actionType: ON_TO_OFF_ACTION_TYPE,
    }).finally(() => {
      window.location.href = SPECIAL_OFFERS_LOCAL_ACCOUNT_DETAIL_URL;
    });
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const rmCodeValue = (searchParams.get(URL_PARAMS.RM_CODE) || '').trim();
    if (rmCodeValue) {
      setRmCode(rmCodeValue);
      setDirty(true);
    }
  }, []);

  return (
    <div>
      <Toolbar
        title={t('product_detail')}
        onBack={() => handleGoBack(history)}
      />
      <div className={styles.header} onClick={handleViewDetail}>
      <img src={PreviewBanner} className="w-full" />
      </div>
      <div className={styles.container}>
        <div className={classNames(styles.sectionHeader, 'mb-2')}>
          <img
            src={InsurancePackageIcon}
            alt={t('insurance_package')}
            className="mr-3"
          />
          <div>
            <h1>{t('insurance_package')}</h1>
            <h2>{t('special_offers_insurance_price_ads')}</h2>
          </div>
        </div>
        <div className={styles.sectionHeader}>
          <img
            src={InsuranceRefundIcon}
            alt={t('insurance_package')}
            className="mr-3"
          />
          <div>
            <h1>{t('great_deals')}</h1>
          </div>
        </div>
        <hr />
        <div className={styles.listDetail}>
          <ul>
            <li>
              {t('refund')} <b>10%</b> {t('up_to')}{' '}
              <b>{t('x_millions', { value: 100 })}</b>
            </li>
            <li>
              {t('voucher')} <b>40%</b> {t('special_offers_refund_2_1')}{' '}
              <b>
                {t('x_vnd', {
                  value: (400000).toLocaleString('en'),
                })}
              </b>
              {t('special_offers_refund_2_2')}
              <b>{t('x_millions', { value: 500 })}</b>
            </li>
            <li>
              {t('account_beauty_number')}{' '}
              <b>{t('x_millions', { value: 100 })}</b>
            </li>
            {/* <li>
              {t('service_donation_local_account')} <b>{t('free')}</b>
            </li> */}
          </ul>
        </div>
        <div className={styles.sectionHeader}>
          <img
            src={InsuranceBenefitIcon}
            alt={t('insurance_benefit')}
            className="mr-3"
          />
          <div>
            <h1>{t('insurance_benefit')}</h1>
          </div>
        </div>
        <hr />
        <div className={styles.listDetail}>
          <ul>
            <li>
              {t('special_offers_package_detail_1_1')}{' '}
              <b>{t('special_offers_package_detail_1_2')}</b>{' '}
              {t('special_offers_package_detail_1_3')}
            </li>
            <li>
              {t('special_offers_package_detail_2_1')}{' '}
              <b>{t('special_offers_package_detail_2_2')}</b>
            </li>
            <li>
              {t('special_offers_package_detail_3_1')}{' '}
              <b>{t('special_offers_package_detail_3_2')}</b>
            </li>
            <li>
              {t('special_offers_package_detail_4_1')}{' '}
              <b>{t('special_offers_package_detail_4_2')}</b>
            </li>
            <li>
              {t('special_offers_package_detail_5_1')}{' '}
              <b>{t('special_offers_package_detail_5_2')}</b>
            </li>
          </ul>
        </div>

        <div className={styles.sectionHeader}>
          <div>
            <h1>
              {t('rm_code')}{' '}
              <label className="bodyText text-error"> *</label>
            </h1>
          </div>
        </div>
        <hr />
        <div className={styles.inputContainer}>
          <TextInput
            value={rmCode}
            onChange={(event) => setRmCode(event.target.value)}
            onBlur={() => {
              setDirty(true);
              setRmCode(rmCode?.trim());
            }}
            placeholder={t('input_rm_code')}
            onInput={handleInputRmCode}
            maxLength={12}
          />
          {!isRmCodeValid && (
            <div className="text-sm text-red-700 mt-1">
              {rmCode
                ? t('rm_code_invalid')
                : t('rm_code_is_require')
              }
            </div>
          )}
        </div>
        <div className="px-5 py-10">
          <div
            className={classNames(
              'flex',
              styles.agreeConfirmContainer,
              isAgreeGetAdvise && styles.isAgree
            )}
          >
            <div>
              <Checkbox
                checked={isAgreeGetAdvise}
                onCheck={handleToggleAgree}
                type="card"
                className={styles.p0}
              />
            </div>
            <label htmlFor="agreeAdvise" onClick={handleToggleAgree}>
              {t('special_offers_agree_get_advise')}
            </label>
          </div>
        </div>
        <hr />
        <div className="flex justify-center pt-4 pb-5 px-5">
          <Button
            text={t('confirm')}
            extraClassName={styles.confirmBtn}
            onClick={handleSubmit}
            disabled={!isAgreeGetAdvise || !rmCode}
          ></Button>
        </div>
      </div>
      <PopupConfirm visible={isShowSuccessModal} icon={LargeCheckWhite}>
        <div className="py-5">
          <p className={classNames('text-center mb-10', styles.successMessage)}>
            {t('special_offers_local_account_success_message_1')}{' '}
            <b>"{t('special_offers_local_account_success_message_2')}"</b>.{' '}
            {t('special_offers_local_account_success_message_3')}
          </p>
          <Button
            text={t('close')}
            extraClassName="w-full"
            onClick={closeSuccessModal}
          ></Button>
        </div>
      </PopupConfirm>
      <PopupConfirm
        visible={isShowErrorModal}
        cancelTitle={t('close')}
        onCancel={() => setShowErrorModal(false)}
        content={t('error_local_account')}
      />
    </div>
  );
};

export default SpecialOffersLocalAccountCampaign;
